// react
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useGoBack } from 'hooks/useGoBack';

import { DirectoryTrackingProvider } from '@karehero/llama/contexts/DirectoryTracking';

// components
import { DirectoryProfile } from '@karehero/llama/components/organisms/DirectoryProfile/DirectoryProfile';
import { Loader } from '@karehero/llama/components/atoms/Loader/Loader';
import { ModalPageTemplate } from '@karehero/llama/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { PageTemplate } from '@karehero/llama/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';

// hooks
import { useGetProviderByRegulatoryIdQuery } from 'store/api/findCare';
import { useTracking } from 'hooks';
import { DirectoryTrackingEvent } from '@karehero/models';
import { AllTrackingEvents } from 'hooks/useTracking';

export const DirectoryProfileView = () => {
  // hooks
  const navigate = useNavigate();
  const goBack = useGoBack();
  const [searchParams] = useSearchParams();
  const { track } = useTracking();

  // provider ID
  const { providerID: paramProviderID } = useParams();
  const providerID = paramProviderID || searchParams.get('provider');

  // fetch data
  const { data: providerData, isLoading: isProviderDataLoading } =
    useGetProviderByRegulatoryIdQuery(providerID || '', { skip: !providerID });

  // effects
  useEffect(() => {
    track(DirectoryTrackingEvent.DirectoryProfileViewed, {
      regulatoryId: providerID,
    });
  }, [track, providerID]);

  return (
    <ModalPageTemplate onBack={goBack}>
      <PageTemplate
        headerSlot={<PageHeader title='Care Provider' />}
        contentSlot={
          isProviderDataLoading || !providerData || !providerID ? (
            <Loader />
          ) : (
            <DirectoryTrackingProvider
              track={(name: string, payload: any) =>
                track(name as AllTrackingEvents, payload)
              }
            >
              <DirectoryProfile provider={providerData} googleMapsApiKey={''} />
            </DirectoryTrackingProvider>
          )
        }
      />
    </ModalPageTemplate>
  );
};

export default DirectoryProfileView;
